import { USERINPUTTYPE } from "../../userinput/internal";
import { Strategy, STRATEGYINITSTATE } from "./internal";
/**
 * Implements a strategy that reloads the layer using a moving bounding box around the current GeoFrame.
 * Once the current GeoFrame reaches the border of the current bounding box, the box is reset and
 * the layer gets reloaded.
 *
 * @class BboxStrategy
 * @extends Strategy
 * @author Joel Burkhard
 */
export class BboxStrategy extends Strategy {
    /**
     * @constructor
     * @param {Scene} scene
     * @param {number} boxdimension. Size of the bounding box around the geoframe in meter
     * @param {number} bordertolerance. Distance to the bounding box border to make an update
     */
    constructor(scene, boxdimension, bordertolerance) {
        super(scene);
        /*
         * event'id for unsubscribing on destroy
         */
        this._geoframechangedevt = null;
        this.boxdimension = boxdimension;
        this.bordertolerance = bordertolerance;
    }
    /**
     * initializes the bbox-strategy once the first layer with this strategy was added.
     * @protected
     */
    _init() {
        super._init();
        if (this.scene.getCurrentGeoframe()) {
            if (this.scene.getCurrentGeoframe())
                this._updatebbox(this.scene.getCurrentGeoframe());
        }
        //register _segmentchanged
        this._geoframechangedevt = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.GEOFRAMECHANGED, (geoframe) => {
            if (this._state == STRATEGYINITSTATE.PENDING) {
                this._updatebbox(geoframe);
            }
            else {
                const within_easting = this._loadinfo.bbox.minx + this.bordertolerance < geoframe.easting &&
                    geoframe.easting < this._loadinfo.bbox.maxx - this.bordertolerance;
                const within_northing = this._loadinfo.bbox.miny + this.bordertolerance < geoframe.northing &&
                    geoframe.northing < this._loadinfo.bbox.maxy - this.bordertolerance;
                if (!within_easting || !within_northing)
                    this._updatebbox(geoframe);
            }
        }, this);
    }
    /**
     * destroys the strategy and unsubsribes registered events.
     * @protected
     */
    _destroy() {
        super._destroy();
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.GEOFRAMECHANGED, this._geoframechangedevt);
        this._geoframechangedevt = null;
    }
    /**
     * updates the box and calls the update-function (load-function of the layer)
     * @param geoframe
     * @private
     */
    _updatebbox(geoframe) {
        const oversize = this.boxdimension / 2.0;
        this._loadinfo.bbox = {
            minx: geoframe.easting - oversize,
            miny: geoframe.northing - oversize,
            maxx: geoframe.easting + oversize,
            maxy: geoframe.northing + oversize,
        };
        this._loadinfo.srid = geoframe.srid;
        this._state = STRATEGYINITSTATE.DONE;
        for (let i = 0; i < this.layers.length; i++) {
            this.layers[i].layer.needsReload = true;
        }
        this._update();
    }
}
//# sourceMappingURL=bboxstrategy.js.map